export default "__VITE_ASSET__DB15UZ$9__"